import { Directive, HostListener } from '@angular/core';
import { Observable } from 'rxjs';

@Directive()
export abstract class ComponentCanDeactivateDirective {
  abstract canDeactivate(): boolean | Observable<boolean>;
  abstract warnOnUnload(): boolean;

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    // Manually blur to trigger change detection in ReactiveForms
    if (document.activeElement) {
      (document.activeElement as any).blur();
    }

    if (this.warnOnUnload()) {
      $event.returnValue = true;
    }
  }
}
